export default "__VITE_ASSET__DsYTQMKy__"